/* generated by pull.js */
const manifest = {
  "editorOnly": true,
  "noTranslations": true,
  "name": "Editor Animations",
  "description": "Adds smooth animations to various aspects of the editor!",
  "credits": [
    {
      "name": "reflow"
    },
    {
      "name": "SharkPool"
    }
  ],
  "info": [
    {
      "type": "notice",
      "text": "This addon will not take effect if you have animations turned off on your system. See https://mgik.dev/turn-on-motion for how to turn it on.",
      "id": "reduced-motion-notice"
    },
    {
      "type": "notice",
      "text": "Some animation types don't support animation direction; therefore, the animation direction may be ignored.",
      "id": "animation-support"
    }
  ],
  "settings": [
    {
      "id": "animateButtons",
      "name": "Animate Buttons",
      "default": true,
      "dynamic": true,
      "type": "boolean"
    },
    {
      "id": "animateLibraries",
      "name": "Animate Libraries (costumes, sprites, sounds, etc)",
      "default": true,
      "dynamic": true,
      "type": "boolean"
    },
    {
      "id": "animateModals",
      "name": "Animate Modals (create variable/list, custom block, etc)",
      "default": true,
      "dynamic": true,
      "type": "boolean"
    },
    {
      "id": "animateSpeed",
      "name": "Animation Speed (1-500%)",
      "type": "integer",
      "dynamic": true,
      "min": 1,
      "default": 100,
      "max": 500
    },
    {
      "id": "animationType",
      "name": "Animation Type",
      "type": "select",
      "dynamic": true,
      "default": "default",
      "potentialValues": [
        { "id": "default", "name": "Default" },
        { "id": "ease", "name": "Ease" },
        { "id": "smoothStep", "name": "Smooth Step" },
        { "id": "fastInSlowOut", "name": "Fast In Slow Out" },
        { "id": "sine", "name": "Sine" },
        { "id": "quad", "name": "Quadratic" },
        { "id": "cubic", "name": "Cubic" },
        { "id": "quart", "name": "Quartic" },
        { "id": "quint", "name": "Quintic" },
        { "id": "back", "name": "Back" },
        { "id": "elastic", "name": "Elastic" },
        { "id": "bounce", "name": "Bounce" },
        { "id": "emphasis", "name": "Emphasis" },
      ]
    },
    {
      "id": "animationDir",
      "name": "Animation Direction",
      "type": "select",
      "dynamic": true,
      "default": "InOut",
      "potentialValues": [
        { "id": "In", "name": "In" },
        { "id": "Out", "name": "Out" },
        { "id": "InOut", "name": "Both" },
      ]
    },
  ],
  "userscripts": [
    {
      "url": "userscript.js"
    }
  ],
  "tags": [
    "theme"
  ],
  "enabledByDefault": true
};
export default manifest;
